import urls from 'config/urls';
import { COOKIES_ROOT_DOMAIN } from 'config/app';
import type { Notification } from 'state/notifier/notifier-initial-state';

// Events that we can receive from o10r
export enum MagicFrameWizardEvent {
  SetAccessToken = 'magic-frame-wizard:set-access-token',
  SyncLocale = 'magic-frame-wizard:sync-locale',
  SetRestrictedPaths = 'magic-frame-wizard:set-restricted-paths',
  SetRoute = 'magic-frame-wizard:set-route',
  SetSessionStorage = 'magic-frame-wizard:set-session-storage',
}

// Events that we can emit to o10r
export enum MagicFrameInnerEvent {
  Notification = 'magic-frame-inner:notification',
  Navigate = 'magic-frame-inner:navigate',
  Error = 'magic-frame-inner:error',
}

export enum MagicFrameInnerErrorEventType {
  UnauthorizedRequest = 'magic-frame-inner:error:unauthorized',
  BadRequest = 'magic-frame-inner:error:bad-request',
}

export interface MagicFrameInnerNotificationEventData {
  message: string;
  color: Notification['type'];
}

export const EMBED_PAGE_PATH = '/embed';

export const O10R_REDIRECT_EXCEPTION_URLS = new Set([
  urls.oauthLogin,
  urls.oauthAuthorize,
  urls.oauthConfirmEmail,
  `${urls.socialAuth}/google`,
  `${urls.socialAuth}/apple`,
  urls.recoverPassword,
  urls.newPassword,
]);

export const COOKIES_SETTINGS = {
  domain: COOKIES_ROOT_DOMAIN,
  secure: true,
  sameSite: 'none',
} as const;
